export default __webpack_public_path__ + "static/media/location-point.cd22844a.svg";